import { useTrackingOp } from "../../../contexts/TrackingOpContext";
import { EXECUTION_TYPE } from "../../../util/varibles/constants";
import { durationTxt } from "../../../util/varibles/global";

export function AutoModeStatus() {
    const [data = Date.now()] = useTrackingOp(state => state.op?.operation.latest_time);
    const [execution_type = Date.now()] = useTrackingOp(state => state.op?.operation.execution_type);
    const duration = Date.now() - data;
    if (execution_type !== EXECUTION_TYPE.AUTO)
        return null;

    return <div className="mt-[-10px] mb-1 bg-[var(--colorHover)] w-[calc(100%+40px)] ml-[-20px] text-[15px] py-2 px-[20px] leading-[20px]">
        <span className="mr-1 color-dark">Auto mode is enabled for this operation. Steps and data are logged automatically from the vessel API. Logging will continue until complete, even after the operation is completed.</span>
        <span className="text-[#E95D5D]">Current data delay: {durationTxt(duration)}.</span>
    </div>
}